// ─── Variables ────────────────────────────────────────────────────────────────
$blue-500: #3b82f6;
$blue-600: #2563eb;
$blue-100: #dbeafe;
$blue-text: #3b82f6;

$slate-50: #f8fafc;
$slate-100: #f1f5f9;
$slate-400: #94a3b8;
$slate-500: #64748b;
$slate-600: #475569;
$slate-700: #334155;
$slate-800: #1e293b;

$red-500: #ef4444;

$white: #ffffff;
$border-radius-lg: 0.5rem;
$border-radius-xl: 0.75rem;
$transition: 150ms ease;

// ─── Layout ───────────────────────────────────────────────────────────────────

.pageWrapper {
    display: flex;
    height: 100vh;
    background-color: $slate-50;
    font-family: sans-serif;
}

.actionHeaderWrapper {
    padding: 20px 16px;
}

.tableWrapper {
    padding: 20px 16px;
}

.backBtn {
    display: inline-flex;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #1d4ed8;
    gap: 4px;

    &:hover {
        color: #1d4ed8;
    }
}

// ─── Sidebar ──────────────────────────────────────────────────────────────────

.sidebar {
    width: 12rem;
    flex-shrink: 0;
    background-color: $white;
    border-right: 1px solid $slate-100;
    display: flex;
    flex-direction: column;
    padding: 0.75rem 0;
    gap: 0.2rem;
}

.sidebarGroupBtn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.5rem 0.75rem;
    margin: 0 0.5rem;
    border-radius: $border-radius-lg;
    font-size: 0.875rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: background-color $transition, color $transition;
    background: transparent;
    color: $slate-700;

    &:hover {
        background-color: $slate-100;
    }

    &.active {
        background-color: $blue-500;
        color: $white;
    }
}

.sidebarChevron {
    transition: transform $transition;
    width: 14px;
    height: 14px;

    &.open {
        transform: rotate(90deg);
    }

    &.closed {
        transform: rotate(-90deg);
    }
}

.sidebarSubMenu {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
    padding-left: 0.75rem;
}

.sidebarSubItem {
    text-align: left;
    font-size: 0.875rem;
    padding: 0.375rem 0.75rem;
    border-radius: $border-radius-lg;
    margin: 0 0.25rem;
    border: none;
    cursor: pointer;
    background: transparent;
    color: $slate-600;
    transition: background-color $transition, color $transition;

    &:hover {
        background-color: $slate-50;
    }

    &.active {
        background-color: $blue-100;
        color: $blue-text;
        font-weight: 500;
    }
}

// ─── Main Content ─────────────────────────────────────────────────────────────

.main {
    flex: 1;
    overflow: auto;
    padding: 0 1.5rem;
}

.contentWrapper {

    margin: 0 auto;
}

// ─── Page Header ──────────────────────────────────────────────────────────────

.pageHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1.25rem;

}

.pageTitle {
    font-size: 18px;
    font-weight: 600;
    color: $slate-800;
    margin: 0;
}

.headerActions {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #f8fafc;
}

// ─── Search ───────────────────────────────────────────────────────────────────

.searchWrapper {
    position: relative;
}

.searchIcon {
    position: absolute;
    left: 0.625rem;
    top: 50%;
    transform: translateY(-50%);
    color: $slate-400;
    width: 14px;
    height: 14px;
    pointer-events: none;
}

.searchInput {
    padding-left: 2.5rem;
    height: 2rem;
    width: 12rem;
    font-size: 0.875rem;
    border: 1px solid #e2e8f0;
    background-color: $white;
    border-radius: $border-radius-lg;
    outline: none;
    color: $slate-700;
    transition: border-color $transition;

    &::placeholder {
        color: $slate-400;
    }

    &:focus {
        border-color: $blue-500;
        box-shadow: 0 0 0 2px rgba($blue-500, 0.15);
    }
}

// ─── Buttons ──────────────────────────────────────────────────────────────────

.refreshBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 2rem;
    width: 2rem;
    border: 1px solid #e2e8f0;
    border-radius: $border-radius-lg;
    background: $white;
    cursor: pointer;
    color: $slate-500;
    transition: background-color $transition;
     border: 1px solid #62748E;
    border-radius: 6px;

    &:hover {
        background-color: $slate-50;
    }

    svg {
        width: 14px;
        height: 14px;
    }
}

.createBtn {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    height: 2rem;
    padding: 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: $white;
    background-color: $blue-500;
    border: none;
    border-radius: $border-radius-lg;
    cursor: pointer;
    transition: background-color $transition;

    &:hover {
        background-color: $blue-600;
    }

    svg {
        width: 14px;
        height: 14px;
    }
}

// ─── Table Card ───────────────────────────────────────────────────────────────

.tableCard {
    background-color: $white;
    border-radius: $border-radius-xl;
    border: 1px solid $slate-100;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    overflow: hidden;
}

.createRoleFormWrapper,
.assignModulesWrapper {
    flex: 1;
    min-width: 280px;
}

.formActions {
    padding: 0.75rem 1rem 1rem;
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
}

.cancelBtn {
    height: 36px;
    padding: 0 18px;
    border-radius: 8px;
    border: 1px solid #62748E;
    background: #ffffff;
    color: #374151;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
    
    &:hover:not(:disabled) {
        background: #f9fafb;
        border-color: #9ca3af;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.saveBtn {
    height: 36px;
    padding: 0 18px;
    border-radius: 8px;
    border: none;
    background: #2563eb;
    color: #ffffff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 150ms ease;

    &:hover:not(:disabled) {
        background: #1d4ed8;
    }

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
}

.table {
    width: 100%;
    border-collapse: collapse;
}

.tableHead {
    th {
        padding: 0.75rem 1rem;
        text-align: left;
        font-size: 0.875rem;
        font-weight: 600;
        color: $slate-600;
        border-bottom: 1px solid $slate-100;
        background: #f8fafc;

        &:last-child {
            text-align: right;
        }
    }
}

.tableRow {
    border-bottom: 1px solid $slate-100;
    transition: background-color $transition;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background-color: rgba($slate-50, 0.6);
    }

    td {
        padding: 0.875rem 1rem;
        font-size: 0.875rem;
        vertical-align: middle;
    }
}

.cellRole {
    font-weight: 500;
    color: $slate-700;
}

.cellMuted {
    color: $slate-500;
}

.cellActions {
    text-align: right;
}

// ─── Role Type Badge ──────────────────────────────────────────────────────────

.roleTypeDefault {
    font-size: 0.75rem;
    font-weight: 500;
    color: $blue-text;
}

.roleTypeCustom {
    font-size: 0.75rem;
    font-weight: 500;
    color: $slate-700;
}

// ─── Action Buttons ───────────────────────────────────────────────────────────

.actionsCell {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem;
}

.viewBtn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.125rem;
    padding: 0.25rem 0.5rem;
    background: transparent;
    border: none;
    border-radius: $border-radius-lg;
    cursor: pointer;
    color: $slate-500;
    transition: color $transition, background-color $transition;

    &:hover {
        color: $blue-500;
        background-color: rgba($blue-500, 0.06);
    }

    svg {
        width: 14px;
        height: 14px;
    }

    span {
        font-size: 0.625rem;
        line-height: 1;
    }
}

.moreBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.75rem;
    width: 1.75rem;
    background: transparent;
    border: none;
    border-radius: $border-radius-lg;
    cursor: pointer;
    color: $slate-400;
    transition: color $transition, background-color $transition;

    &:hover {
        color: $slate-600;
        background-color: $slate-100;
    }

    svg {
        width: 14px;
        height: 14px;
    }
}

// ─── Empty State ──────────────────────────────────────────────────────────────

.emptyRow td {
    text-align: center;
    padding: 2.5rem 1rem;
    color: $slate-400;
    font-size: 0.875rem;
}

// ─── Pagination ───────────────────────────────────────────────────────────────

.pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    padding: 1rem;
}

.pageNavBtn {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
    background: transparent;
    border: none;
    border-radius: $border-radius-lg;
    cursor: pointer;
    color: $slate-500;
    transition: background-color $transition;

    &:hover:not(:disabled) {
        background-color: $slate-100;
    }

    &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
    }

    svg {
        width: 14px;
        height: 14px;
    }
}

.pageNumBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    font-size: 0.75rem;
    background: transparent;
    border: none;
    border-radius: $border-radius-lg;
    cursor: pointer;
    color: $slate-500;
    transition: background-color $transition, color $transition;

    &:hover {
        background-color: $slate-100;
    }

    &.activePage {
        background-color: $blue-500;
        color: $white;

        &:hover {
            background-color: $blue-600;
        }
    }
}

.pageDots {
    font-size: 0.75rem;
    color: $slate-400;
    padding: 0 0.25rem;
}

// ─── Table Card Header (inside card) ─────────────────────────────────────────

.tableCard {
    .pageHeader {
        padding: 1rem 1.25rem;
        margin-bottom: 0;
        border-bottom: 1px solid $slate-100;
    }
}